import angular from 'angular';

import ConstantsService from './constants.service';

let constantsModule = angular.module('constants', [])
.service('ConstantsService', ConstantsService);

export default constantsModule;



// WEBPACK FOOTER //
// ./client/common/services/constants/constants.js